import axios from "axios";
import React, { useEffect, useState } from "react";
import { Col, Container, Row, Card, Button } from "react-bootstrap";
import ReactTost from "../ReactTost";
import { set, useForm } from "react-hook-form";
import BtnLoader from "../BtnLoader";
import { useTranslation } from "react-i18next";
import QuantityPicker from "../QuantityPicker";
import UserPlanDelete from "../User/Modal/UserSubscriptionDelete";
import { act } from "react-dom/test-utils";

const MyProfile = () => {
  const user = localStorage.getItem("id");
  const { t } = useTranslation();
  const API_URL = process.env.REACT_APP_API_URL;
  const API_VERSION = process.env.REACT_APP_API_VERSION;
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const {
    handleSubmit,
    register,
    formState: { errors },
    setValue,
  } = useForm();
  const [activePlan, setActivePlan] = useState([]);
  const [msg, setMsg] = useState();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [type, setType] = useState("");
  const [message, setMessage] = useState("");
  const [planId,setPlanId] = useState(0);
  const [showAlert, setShowAlert] = useState(false);
  const [loading, setLoading] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);
  const [addOnPayLoading, setAddOnPayLoading] = useState(false);
  const [price, setPrice] = useState(0);
  const [messageLimit, setMessageLimit] = useState(0);
  const [addOnsUpdateId, setAddOnsUpdateId] = useState(0);

  function UpdateUser(data) {
    setLoading(true);
    axios
      .patch(
        `${API_URL}/${API_VERSION}/user/${user}`,
        {
          name: data.name,
          email: data.email,
        },
        {
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then((response) => {
        setLoading(false);
        setType("Success");
        setMessage(t("Profile updated."));
        setShowAlert(true);
      })
      .catch((error) => {
        setLoading(false);
        setType("Danger");
        setMessage(
          error.response.data.message
            ? error.response.data.message
            : t("Something went to wrong.")
        );
        setShowAlert(true);
      });
  }

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${API_URL}/${API_VERSION}/user/${user}`, {
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        setLoading(false);
        setValue("name", response.data.name);
        setEmail(response.data.email);
      })
      .catch((error) => {
        setLoading(false);
        setType("Danger");
        setMessage(
          error.response.data.message
            ? error.response.data.message
            : t("Something went to wrong.")
        );
        setShowAlert(true);
      });
  }, [user, API_URL, API_VERSION]);


  return (
    <>
      <section className="userdoc_main my-4">
        <ReactTost
          onHide={() => {
            setShowAlert(false);
            setType("");
            setMessage("");
          }}
          alertClass={type}
          alertMessage={message}
          alertDo={showAlert}
        />
        <Container>
          <Row className="justify-content-center mt-5">
            <Col md={6} className="mb-4">
              <Card>
                <form onSubmit={handleSubmit(UpdateUser)}>
                  <Card.Body className="p-4">
                    <h4>{t("Edit profile")}</h4>
                    <Row>
                      <Col md={12}>
                        <div className="mb-3">
                          <label htmlFor="" className="form-label">
                            {t("Name")}
                          </label>
                          <input
                            type="text"
                            className={`form-control ${
                              errors.name ? "is-invalid" : ""
                            }`}
                            id="name"
                            name="name"
                            // value={name}
                            onChange={(event) => setName(event.target.value)}
                            {...register("name", {
                              required: t("Name is required"),
                            })}
                          />
                          {errors.name && (
                            <div className="invalid-feedback">
                              {errors.name.message}
                            </div>
                          )}
                        </div>
                      </Col>
                      <Col md={12}>
                        <div className="mb-3">
                          <label htmlFor="" className="form-label">
                            {t("Email")}
                          </label>
                          <input
                            readOnly
                            disabled
                            type="text"
                            className="form-control"
                            id="email"
                            name="email"
                            value={email}
                            onChange={(event) => setEmail(event.target.value)}
                          />
                        </div>
                      </Col>
                      <Col md={12} className="text-end">
                        <button
                          type="submit"
                          value={t("UPDATE")}
                          className="userbutton mt-3"
                          disabled={loading}
                        >
                          {loading ? <BtnLoader /> : t("UPDATE")}
                        </button>
                      </Col>
                    </Row>
                  </Card.Body>
                </form>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default MyProfile;
